import React from 'react'
import { Outlet } from 'react-router-dom'
import {
  CategoryScale,
  Chart as ChartJS,
  LinearScale,
  LineElement,
  PointElement,
  ScatterController,
  Tooltip
} from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'

ChartJS.register(annotationPlugin, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, ScatterController)

// defined auto because login micro-front sets overflow to hidden
document.body.style.overflow = 'auto'

export const App: React.FC = () => {
  return <Outlet />
}
